import { render, staticRenderFns } from "./call-center-history-call.vue?vue&type=template&id=723dbf92"
import script from "./call-center-history-call.vue?vue&type=script&lang=ts"
export * from "./call-center-history-call.vue?vue&type=script&lang=ts"
import style0 from "./call-center-history-call.vue?vue&type=style&index=0&id=723dbf92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCol,VLayout,VRow,VTimeline,VTimelineItem})
